import Vue from 'vue';

export default Vue.component('ed-list-item-checkbox', {
  name: 'ed-list-item-checkbox',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    borderless: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    value: { 
    },
    modelValue: { 
      default: ''
    },
    trueValue: { 
      default: true
    },
    falseValue: { 
      default: false
    },
  },
  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      }

      return this.modelValue === this.trueValue
    }
  },
  methods : {
    updateInput(event) {
      let isChecked = event.target.checked
      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue]
        if (isChecked) {
          newValue.push(this.value)
        } else {
          newValue.splice(newValue.indexOf(this.value), 1)
        }
        this.$emit('change', newValue)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    }
  }
});